import { useRef } from 'react';
import { Button } from '@src/design-system/button';
import { Textfield } from '@src/shared/fields/text-field';
import { Form, Formik } from 'formik';
import { object, string } from 'yup';

import type { TReminderTemplate } from '@src/shared/types/reminder-template';
import { useTestReminderEmail } from '@src/features/reminders/services/test-reminder';
import { DialogClose, DialogFooter } from '@src/design-system/dialog';
import { showToast } from '@src/shared/utils/helpers/show-toast';

export const TestEmail = ({
  reminderTemplate,
}: {
  reminderTemplate: TReminderTemplate;
}) => {
  const closeRef = useRef<HTMLButtonElement>(null);
  const { mutate: testReminderEmail, isPending } = useTestReminderEmail();

  const handleSubmit = async (values: { email: string }) => {
    testReminderEmail(
      { email: values.email, template: reminderTemplate.id },
      {
        onSuccess: () => {
          showToast({
            title: 'Sent Successfully',
            description: 'Your test mail has been sent successfully.',
            variant: 'success',
          });
          closeRef.current?.click();
        },
      }
    );
  };

  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={object().shape({
        email: string().email('Invalid email').required('Email is required'),
      })}
      onSubmit={handleSubmit}
    >
      <Form className='flex min-h-full flex-col'>
        <div className='flex-1'>
          <Textfield
            type='email'
            name='email'
            label='Reminder Test'
            placeholder='Enter Your Email'
            helperText='Enter your mail to receive a test message.'
          />
        </div>

        <DialogFooter className='mt-auto shrink-0 bg-white p-0 pt-4 grid grid-cols-2 gap-2'>
          <Button
            type='submit'
            disabled={isPending}
          >
            Send Test Mail
          </Button>
          <DialogClose
            ref={closeRef}
            asChild
          >
            <Button variant='primaryOutline'>Cancel</Button>
          </DialogClose>
        </DialogFooter>
      </Form>
    </Formik>
  );
};
